import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { SceneTreeNode } from "../scene/SceneTreeItem";

/**
 * Type guard to check if a SceneTreeNode is of dataType "layer"
 */
export function isSceneLayerNode(node: SceneNodeItem): node is SceneNodeItem<"layer"> {
  return node.dataType === "layer";
}

export function isLayerTreeNode(node: SceneTreeNode): node is SceneTreeNode<"layer"> {
  return node.node.dataType === "layer";
}
